module.exports = "div.card.bq360-alert-separate-top {\n  margin-top: 15px !important;\n}\n\ntr.bq-alert-clickable {\n  cursor: help;\n  font-size: 13px;\n}\n\n"